export default __webpack_public_path__ + "static/media/pantry1-afterH.86a82756.jpg";